import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'App config Info Mass update (only filled fields will be updated)',
  attributeName: 'appConfigInfo',
  fields: [
    {
      attributeName: 'app',
      helpText: 'App',
      type: FormInputTypes.SELECT,
      label: 'App',
      placeholder: 'Please enter to select an app',
      multiple: false,
      url: 'liveAppslist',
      emptyValue:true,
      childField:'config',
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName: 'config',
      helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
      type: FormInputTypes.SELECT,
      label: 'Config',
      placeholder: 'Please enter to add a valid config',
      multiple: false,
      url: 'liveConfigslist',
      parentField:'app',
      enabledWhen:{"field":"app","notValues":['(Empty)']},
      emptyValue:true,
      childField:'appCategories',
      default:'(Empty)', //default value to empty option
      allValue:'(All)',
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'composeExperienceUrl',
      helpText: 'Select a valid media Url',
      type: FormInputTypes.SELECT,
      label: 'ComposeExperience Url',
      placeholder: 'Please add a valid media url',
      multiple: false,
      url: 'liveComposeExperienceList',
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'url',
      asyncSelect: true,
      pageId:true,
      options:[]
    },
    // {
    //   attributeName: 'duration',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   label: 'Duration',
    //   placeholder: 'Video duration...',
    //   helpText: 'Duration of the video in the format mm:ss.',
    // },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation Time',
      helpText: 'Date of the activation event for this video in clients.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'playerVersion',
      label: 'Player version',
      helpText: 'Player version of the video.',
      type: FormInputTypes.SELECT,
      emptyValue:true,
      options: [
        { name: 'YBVR', value:'YBVR' },
        { name: 'AVPRO', value: 'AVPRO' },
      ],
    },
    {
      attributeName: 'geometry',
      label: 'Geometry',
      helpText: 'Signaling version of the video.',
      type: FormInputTypes.SELECT,
      emptyValue:true,
      options: [
        { name: 'Autodetect', value: 'v2' },
        { name: 'Equirectangular', value: 'equirectangular' },
        { name: 'Equidome', value: 'equidome' },
        { name: 'Flat', value: 'flat' },
      ],
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.SELECT,
      emptyValue:true,
      helpText: 'Whether the video is mono or stereo.',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Stereo', value: 'stereo' },
        { name: 'Stereo LR', value: 'stereolr' },
      ],
      visibleWhen:[{"field":"geometry","notValue":"v2"}]

    },
    {
      attributeName: 'isAudioRecordingAllowed',
      label: 'Allow Audio feedback ',
      helpText: 'Specifies if the content allow audio feedback.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName: 'isSlowMotionAllowed',
      label: 'Allow Slow motion ',
      helpText: 'Specifies if the content allow slow motion.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName: 'isTimeShiftingAllowed',
      label: 'Allow Timeshift ',
      helpText: 'Specifies if the content allow slow motion.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
    {
      attributeName:"sep5",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster',
      helpText: 'Any valid url to a PNG poster image file.',
      placeholder: 'Video poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'largePoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Large Poster',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',
      placeholder: 'Video large poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'descriptionPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      fileType: ['image/*'],
    },
    {
      attributeName: 'description',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Description',
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
    {
      attributeName: 'producers',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Producers',
      placeholder: 'Video producers...',
      helpText: 'Producers of the video.',
    },
    {
      attributeName: 'backgroundFlat',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Flat',
      helpText: 'Background to use in the flat video geometries.',
      fileType: ['image/*'],
      hasSelect:false,
    },
    {
      attributeName: 'background180',
      type: FormInputTypes.BACKGROUND,
      label: 'Background 180',
      helpText: 'Background to use in the 180 video geometries.',
      fileType: ['image/*'],
      hasSelect:false,
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'visibility',
      label: 'Visibility',
      helpText: 'Visibility of the video in the panel its listed.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
    },
    {
      attributeName: 'isHighQuality',
      label: 'Is High Quality',
      helpText: 'Whether the video is in 8K quality.',
      default: '(Empty)',
      emptyValue:true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Yes', value: 'yes' },
        { name: 'No', value: 'no' },
      ],
    },
   
  ],
};
